import React, {Component} from 'react';
import { Switch, Route } from 'react-router-dom';

import Header from './header';
import Tabs from './tabs';
import History from './history';

class View extends Component {

    componentDidMount() {
        const { isPersonal, firstAthleteId, match: { params: { athleteid } } } = this.props;
        if (isPersonal && !athleteid) {
            if (firstAthleteId) {
                this.props.history.replace(`/athletes/${firstAthleteId}`);
            } else {
                this.props.fetchAthletes();
            }
        } else {
            this.props.fetchAthlete(athleteid);
        }
        window.scrollTo(0, 0); // TODO: this may not be the best way to accomplish it
    }

    componentDidUpdate(prevProps) {
        const { isPersonal, firstAthleteId, match: { params: { athleteid } } } = this.props;
        if (isPersonal && !athleteid && firstAthleteId && firstAthleteId !== prevProps.firstAthleteId) {
            this.props.history.replace(`/athletes/${firstAthleteId}`);
        }
    }

    render() {
        if (!this.props.athlete) {
            return null;
        }

        return (
            <div>
                <Header athleteId={this.props.athlete.id}/>
                <Tabs />
                <Switch>
                    <Route path='/athletes/:athleteid/:athletename' component={History} />
                </Switch>
            </div>
        );
    }

}

export default View;
